import {Component, EventEmitter, Input, Output} from "@angular/core";
import {AppSearchFacetOption} from "../../../models/appSearch.model";

@Component(
        {
            selector: 'catalogue-app-search-hierarchy-facet-option',
            templateUrl: './app-search-hierarchy-facet-option.component.html',
            styleUrls: [
                './app-search-hierarchy-facet-option.component.scss'
            ],
        }
)
export class AppSearchHierarchyFacetOptionComponent {
    @Input() public facetOption: AppSearchFacetOption;
    @Output() public toggleFacetOption = new EventEmitter();
}